import { apiRequest, apiRoutes } from '../../api';
import React, { useState, useEffect, useCallback } from 'react';
import {
    Chip
} from '@mui/material';
import { LocationOn } from '@mui/icons-material';

const POIControl = ({
    isVisible,
    onToggle,
    onPOIsLoad,
    onPOISelect,
    selectedPOI,
    mapBounds
}) => {
    const [poiTypes, setPOITypes] = useState([]);
    const [selectedPOIType, setSelectedPOIType] = useState('');
    const [, setPois] = useState([]);
    const [loading, setLoading] = useState(false);
    const [, setError] = useState(null);
    const [, setPOIDetails] = useState(null);
    const [, setLoadingDetails] = useState(false);

    // Load available POI types on component mount
    useEffect(() => {
        loadPOITypes();
    }, []);

    // Load POIs when POI type changes or component becomes visible
    useEffect(() => {
        if (isVisible && selectedPOIType) {
            loadPOIs();
        }
    }, [selectedPOIType, isVisible]);

    // Load POI details when a POI is selected
    useEffect(() => {
        if (selectedPOI) {
            // Use osm_id as the identifier for POI details
            loadPOIDetails(selectedPOI.osm_id);
        } else {
            setPOIDetails(null);
        }
    }, [selectedPOI]);

    const loadPOITypes = async () => {

        try {
            const url = apiRoutes.poi.types;

            const response = await apiRequest(url);

            const data = await response.json();

            if (response.ok) {

                setPOITypes(data.poi_types || []);
            } else {

                setError('خطا در بارگذاری انواع POI');
            }
        } catch (err) {

            setError('خطا در ارتباط با سرور: ' + err.message);
        }
    };

    const loadPOIs = useCallback(async () => {
        if (!selectedPOIType || loading) return;

        setLoading(true);
        setError(null);

        try {
            let url = `${apiRoutes.poi.data}?poi_type_id=${encodeURIComponent(selectedPOIType)}`;

            // Add bounds if available
            if (mapBounds) {
                const boundsStr = `${mapBounds.getWest()},${mapBounds.getSouth()},${mapBounds.getEast()},${mapBounds.getNorth()}`;
                url += `&bounds=${boundsStr}`;

            }

            const response = await apiRequest(url);

            const data = await response.json();

            if (response.ok) {
                // Handle GeoJSON format - extract features array
                const poisData = data.pois?.features || data.pois || [];

                setPois(poisData);
                onPOIsLoad(poisData);
            } else {

                setError(data.error || 'خطا در بارگذاری POI ها');
            }
        } catch (err) {

            setError('خطا در ارتباط با سرور: ' + err.message);
        } finally {
            setLoading(false);
        }
    }, [selectedPOIType, loading, mapBounds, onPOIsLoad]);

    const loadPOIDetails = async (poiId) => {

        setLoadingDetails(true);
        try {
            const url = apiRoutes.poi.details(poiId);

            const response = await apiRequest(url);

            const data = await response.json();

            if (response.ok) {

                setPOIDetails(data);
            } else {

            }
        } catch (err) {

        } finally {
            setLoadingDetails(false);
        }
    };

    const handlePOITypeSelect = (poiType) => {

        if (selectedPOIType === poiType) {
            // Deselect if already selected

            setSelectedPOIType('');
            setPois([]);
            onPOIsLoad([]);
            setPOIDetails(null);
            onToggle(false);
        } else {
            // Select new type

            setSelectedPOIType(poiType);
            onToggle(true);
        }
    };

    return (
        <div className="poi-control-container">
            <div className="poi-types-container">
                {poiTypes.map((poiType) => (
                    <Chip
                        key={poiType.id}
                        label={poiType.display_name || poiType.type}
                        size="small"
                        clickable
                        onClick={(e) => {
                            e.stopPropagation();

                            handlePOITypeSelect(poiType.id);
                        }}
                        className={`poi-chip ${selectedPOIType === poiType.id ? 'selected' : ''}`}
                        icon={poiType.searchable === 1 ? <LocationOn fontSize="small" /> : undefined}
                    />
                ))}
            </div>
        </div>
    );
};

export default POIControl;
